export enum KycRequestType {
  PhotoId = 1,
  ProofOfAddress = 2,
  PaymentMethod = 3,
  KycApproval = 4,
  SourceOfWealthQuestionnaire = 5,
  SourceOfWealthSupportingDocument = 6,
  SourceOfFunds = 7,
  SSN = 8,
  KBAVerification = 9,
  ScanVerification = 10,
}
